export enum ActivationPopupsSensitivity {
  low = "low",
  lowMedium = "low-medium",
  medium = "medium",
  highMedium = "high-medium",
  high = "high"
}
